import { Group, Layers, Material, Mesh, MeshStandardMaterial, Scene } from "three";
import { SceneManager } from "../SceneManager";
import ISceneGeometry from "./ISceneGeometry";
import SceneObjectData from "../sceneObjectData/SceneObjectData";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { getSceneObjectStyle, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";
import { disposeGroup } from "../../utils/disposeUtils";

export default abstract class SceneGeometry<T> implements ISceneGeometry {
    data : T | null = null;
    group: Group;
    style: SceneObjectStyle = getSceneObjectStyle(SceneObjectStyleEnum.Normal);

    constructor() {
        this.group = new Group();
        this.group.name = this.constructor.name;
    }

    getScene(): Scene {
        return SceneManager.scene;
    }

    addToScene(): void {
        this.getScene().add(this.group);
    }

    removeFromScene() : void {
        this.group.parent?.remove(this.group);
    }

    show() {
        this.group.visible = true;
    }

    hide() {
        this.group.visible = false;
    }

    
    dispose() {
        disposeGroup(this.group);
    }

    getMaterials(): Material[] {
        const materials: Material[] = [];
        this.group.traverse((child)  => {
            if (child instanceof Mesh)
            {
                const childMesh = child as Mesh;
                if (Array.isArray(childMesh.material)) {
                    materials.push(...childMesh.material);
                }
                else {
                    materials.push(childMesh.material);
                }
            }
        }
        );
        return materials;
    }

    setLayer = (layer: number) => {
        const layers = new Layers();
        layers.set(layer);
        this.setLayers(layers);
    }

    setLayers = (layer: Layers): void => {
        this.group.traverse((obj) => {
            obj.layers = layer;
        });
    }

    resetStyle(): void {
        this.setStyle(getSceneObjectStyle(SceneObjectStyleEnum.Normal));
    }

    setStyle(style: SceneObjectStyle): void {
        if (this.style === style) {
            return; // No change
        }

        const setMaterialColor = (material: MeshStandardMaterial | any, color: number) => {
                    if (material instanceof MeshStandardMaterial) {
                        material.emissive.setHex(color);
                    }
                    material.color.setHex(color);
                };

        this.getMaterials().forEach((material) => {
            if (material instanceof LineMaterial) {
                (material as LineMaterial).linewidth = style.lineWidth;
            };

            setMaterialColor(material, style.color);
        });

        this.style = style;
    }

    update(data: SceneObjectData, forceUpdate: boolean = false): boolean {
        //this.group.name = data.type;
        this.group.userData = data;
        return this.updateGeometry(data, forceUpdate);
    }

    // Base implementation does nothing
    onAnnotationDirectionChange(rotationOffset: number): void {}

    protected abstract updateGeometry(data:SceneObjectData, forceUpdate: boolean): boolean;
    
}